var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-input',_vm._g(_vm._b({ref:"ezInputRef",on:{"input":function($event){},"&input":function($event){return _vm.valueChanged.apply(null, arguments)}}},'el-input',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }